var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cuid from 'cuid';
function objectField(args) {
    const { properties, fields } = args, resolvedArgs = __rest(args, ["properties", "fields"]);
    const props = properties || fields;
    if (!props) {
        throw new Error('objectField must be passed a properties object');
    }
    return Object.assign(Object.assign({ type: 'object' }, resolvedArgs), { properties: props });
}
/**
 * Used for recursively defined field schemas. Replaces the original properties
 * of an object field with the provided fields. This will mutate the original field.
 */
function replaceObjectFields(object, fields) {
    object.properties = fields;
    return object;
}
function arrayField(args) {
    return Object.assign({ type: 'array' }, args);
}
/**
 * Used for recursively defined field schemas. Replaces the original items
 * of an array field with the provided items. This will mutate the original field.
 */
function replaceArrayItems(array, items) {
    array.items = items;
    return array;
}
const stringField = (args) => {
    return Object.assign({ type: 'string' }, args);
};
const numberField = (args) => {
    return Object.assign({ type: 'number' }, args);
};
const booleanField = (args) => {
    return Object.assign({ type: 'boolean' }, args);
};
const anyField = (args) => {
    return Object.assign({ type: 'any' }, args);
};
function mapField(args) {
    return Object.assign({ type: 'map' }, args);
}
/**
 * Used for recursively defined field schemas. Replaces the original values
 * of a map field with the provided values. This will mutate the original field.
 */
function replaceMapValues(map, values) {
    map.values = values;
    return map;
}
const fileField = (args) => {
    return Object.assign({ type: 'file' }, args);
};
/**
 * Meant for use on primary key fields. Do not use this to refer
 * to another document as a 'foreign key'
 */
const idField = () => {
    return {
        type: 'string',
        default: cuid,
    };
};
export const fields = {
    object: objectField,
    array: arrayField,
    replaceObjectFields,
    replaceArrayItems,
    string: stringField,
    number: numberField,
    boolean: booleanField,
    any: anyField,
    map: mapField,
    replaceMapValues,
    file: fileField,
    id: idField,
};
//# sourceMappingURL=fieldHelpers.js.map